export const NotificationsKeys = {
	all: ["notifications"] as const,
	list: (unreadOnly?: boolean) =>
		[...NotificationsKeys.all, "list", unreadOnly] as const,
	infiniteList: (unreadOnly?: boolean) =>
		[...NotificationsKeys.all, "list", "infinite", unreadOnly] as const,
	count: () => [...NotificationsKeys.all, "count"] as const,
	infiniteGroupedList: (unreadOnly?: boolean) =>
		[
			...NotificationsKeys.all,
			"grouped",
			"list",
			"infinite",
			unreadOnly,
		] as const,
	groupedCount: (unreadOnly?: boolean) =>
		[...NotificationsKeys.all, "grouped", "count", unreadOnly] as const,
};
